import script from "./StringPeelTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StringPeelTable.vue?vue&type=script&setup=true&lang=js"

import "./StringPeelTable.vue?vue&type=style&index=0&id=d038af3c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d038af3c"]])

export default __exports__